/*
 * Copyright (c) 2017. Code réalisé par IpsoSenso
 */

import { unflatten } from 'flat'
import 'whatwg-fetch'
import { logOut } from '../modules/fo/login/services/loginActions'
import { LOCAL_STORAGE_ITEM } from './constants'

let Store = null

const promises = {}

export const saveStore = (createdStore) => {
	Store = createdStore
}

/**
 * Convertit les messages d'erreur reçus du serveur au format Intl.
 *
 * Petite subtilité pour l'attribut `values` qui doit être un Object.
 *
 * @param error
 */
const convertError = error => ({
	id: error.code || '__ERROR__',
	ids: error.codes,
	defaultMessage: error.defaultMessage,
	values: Object.assign({}, error.arguments, {
		rejectedValue: error.rejectedValue
	})
})

export const checkErrors = ([response, json]) => {
	if (response.status === 400) {
		// conversion des erreurs

		// erreurs globales
		const globalErrors = (json.globalErrors || [])
			.map(convertError)
			.reduce((previousValue, currentValue) => [...previousValue, currentValue], [])
		// erreurs sur les champs du formulaire

		const fieldErrors = (json.fieldErrors || [])
			.map(error => ({
				[error.field.replace(/\[(\d)]/g, '.$1')]: convertError(error)
			}))
			.reduce((previousValue, currentValue) => ({
				...previousValue,
				...currentValue
			}), {})

		return Promise.reject({
			_error: globalErrors,
			...unflatten(fieldErrors),
			response,
			bodyError: json
		})
	}
	return json
}

const handleResponse = (response) => {
	// vérification du token
	if (response.status === 401) {
		// si le token n'est pas valide...
		return response.text().then(result => {
			// on déconnecte l'utilisateur
			Store.dispatch(logOut())
		})
	}
	if (response.status === 204) {
		// no content
		return Promise.resolve()
	}
	if (!response.ok && response.status !== 400) {
		// si la réponse est en erreur sauf erreur de validation, on rejette l'appel
		return Promise.reject(response)
	}
	// dans tous les autres cas, la réponse est traitée en JSON
	return Promise.all([response, response.json()])
		.then(checkErrors)
}

export const customFetchFactory = (path, config = {}, apiUrl = '/api/admin') => {
	const {
		headers,
		...others
	} = config
	const token = localStorage.getItem(LOCAL_STORAGE_ITEM.TOKEN) || null
	const defaultHeaders = {
		Accept: 'application/json',
		'Content-Type': 'application/json;charset=utf-8'
	}
	if (token) {
		defaultHeaders.Authorization = token
	}
	const newConfig = {
		headers: {
			...defaultHeaders,
			...headers
		},
		...others
	}
	const key = `${apiUrl}${path}${JSON.stringify(newConfig.body)}`

	if (!promises[key]) {
		promises[key] = fetch(`${process.env.REACT_APP_SERVER_URL}${apiUrl}${path}`, newConfig)
			.then(handleResponse)
			.then(response => {
				delete promises[key]
				return response
			})
			.catch((e) => {
				delete promises[key]
				throw e
			})
	}
	return promises[key]

}

/**
 * Effectue la requête à l'API pour mettre à jour le token de l'utilisateur
 */
export const refreshToken = (token, data) => {
	return fetch(`${process.env.REACT_APP_SERVER_URL}/auth/refresh-veolia`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json; charset=utf-8',
			Authorization: token
		},
		body: JSON.stringify(data)
	}).then((response) => {
		if (response.ok) {
			return response.json()
		}
	})
}
